import { Component, Input, OnInit, OnDestroy, OnChanges, Output, EventEmitter } from '@angular/core';
import { WeGoConfig } from '../../shared/config';

@Component({
  selector: 'wego-driver-search-list',
  template: `
  <form (ngSubmit)="OnSearch()" class="form-inline mar_bot_10">
    <div class="form-group">
      <div class="input-group">
        <input type="text" class="form-control" [(ngModel)]="searchTerm" name="searchTerm" autocomplete="off" maxlength="100">
          <div class="input-group-btn">
            <button class="btn btn-default" type="submit">
              <i class="fa fa-search" aria-hidden="true"></i>
            </button>
          </div>
        </div>
      </div>
    <div class="form-group">
      <button class="btn btn-success" type="button" (click)="OnReset($event)">
        <i class="fa fa-eraser" aria-hidden="true"></i>
      </button>
    </div>
    <div *ngIf="isExported" class="form-group">
      <button class="btn btn-success" type="button" (click)="OnExport($event)" title="{{'LblExportAll(CSV)' | translate}}">
        <i class="fa fa-download" aria-hidden="true"></i>
      </button>
    </div>
    <div *ngIf="isDeleted" class="form-group">
      <button [disabled]="!isDeleteEnabled" class="btn btn-success" type="button" (click)="OnDeleteAll($event)" title="{{'LblDeleteAllSelectedRecords' | translate}}">
        <i class="fa fa-trash-o" aria-hidden="true"></i>
      </button>
    </div>
      <div *ngIf="isCancel" class="form-group">
      <button [disabled]="!isCancelEnabled" class="btn btn-success" type="button" (click)="OnCancelAll($event)" title="{{'LblCancelAllSelectedRecords' | translate}}">
        <i class="fa fa-times" aria-hidden="true"></i>
      </button>
    </div>
     <div *ngIf="isAdd" class="form-group">
      <button [disabled]="!isAddEnabled" class="btn btn-success" type="button" (click)="OnAdd($event)" title="All Selected Record">
        <i class="fa fa-plus-square" aria-hidden="true"></i>
      </button>
    </div>
    <div class="form-group">
      <select class="form-control" title='Items Per Page'  [(ngModel)]="itemPerPage"  name="itemPerPage" (change)="OnPagingChange($event.target.value)">
         <option *ngFor="let item of itemPerPageList"  [attr.value]='item.value' >{{ item }}</option>
      </select>
    </div>
  </form>
  `,
  styles: [
    `
    .form-control{
      border: none;
      border-radius: 3px;
    }
    .btn-default{
      height: 34px;
      border-radius: 0;
      border: 0;
    }
    .btn-success{
      height: 34px;
      border-radius: 0;
    }
    `
  ]
})

export class DriverSearchListComponent implements OnInit, OnDestroy {
  @Output('OnSearch') onSearch = new EventEmitter();
  @Output('OnExport') onExport = new EventEmitter();
  @Output('OnDeleteAll') onDeleteAll = new EventEmitter();
  @Output('OnCancelAll') onCancelAll = new EventEmitter();
  @Output('OnAdd') onAdd = new EventEmitter();
  @Output('OnPagingChange') onPagingChange = new EventEmitter();

  @Input('IsExported') isExported: boolean = true;
  @Input('IsDeleted') isDeleted: boolean = false;
  @Input('IsDeleteEnabled') isDeleteEnabled: boolean = false;

  @Input('IsCancel') isCancel: boolean = false;
  @Input('IsCancelEnabled') isCancelEnabled: boolean = false;
  @Input('IsAdd') isAdd: boolean = false;
  @Input('IsAddEnabled') isAddEnabled: boolean = false;

  @Input('SearchTerm') searchTerm: string = '';
  itemPerPageList: any;
  @Input('ItemPerPage') itemPerPage: any;

  constructor() { }

  ngOnInit() {
    this.itemPerPageList = WeGoConfig.GRID_PAGGING;
    // let itemperPage = localStorage.getItem("itemsPerPage");
    // if (itemperPage) {
    //   this.itemPerPage = itemperPage
    // }
    // else {
    //   this.itemPerPage = WeGoConfig.GRID_MAX_DATA_SIZE;
    // }
  }

  OnReset($event: any) {
    this.searchTerm = "";
    this.onSearch.emit({ searchTerm: this.searchTerm, isReset: true });
  }

  OnSearch() {
    this.onSearch.emit({ searchTerm: this.searchTerm, isReset: false });
  }

  OnExport($event: any) {
    this.onExport.emit($event);
  }

  OnPagingChange($event: any) {
    this.onPagingChange.emit({ itemPerPage: $event });
    // localStorage.setItem('itemsPerPage', $event);
  }

  OnDeleteAll($event: any) {
    this.onDeleteAll.emit($event);
  }

  OnCancelAll($event: any) {
    this.onCancelAll.emit($event);
  }
  OnAdd($event: any) {
    this.onAdd.emit($event);
  }
  ngOnDestroy() { }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/components/driver-search-list.component.ts